import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-198f9a6f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "p-4 full-width"
}
const _hoisted_2 = { class: "welcomeBanner" }
const _hoisted_3 = {
  key: 1,
  class: "p-5 full-width"
}
const _hoisted_4 = {
  key: 2,
  class: "p-4 mb-5 full-width"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Featured Offers", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-4" }, "Curated offers from Mini City partners.", -1))

import OffersCarousel from '@/features/partnerOffers/OffersCarousel.vue';
import OffersCategory from '@/features/partnerOffers/OffersCategory.vue';
import { onMounted, ref } from 'vue';
import { getHomePageOffers, logImpressions } from '@/features/partnerOffers/api';
import { PartnerOffer } from '@/features/partnerOffers/model';
import ApplicationStatusPanel from '@/features/applicationStatus/ApplicationStatusPanel.vue';

import { chromeless, sessionState, startNewEngagement } from "@/core/session";


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {


const carouselOffers = ref<PartnerOffer[]>([]);
const featuredOffers = ref<PartnerOffer[]>([]);

onMounted(() => {
  startNewEngagement();
  
  getHomePageOffers().
    then(offers => {
      carouselOffers.value = offers.carouselOffers;
      featuredOffers.value = offers.featuredOffers;

      logImpressions("home/carousel", offers.carouselOffers);
      logImpressions("home/featured", offers.featuredOffers);
    });
});


return (_ctx: any,_cache: any) => {
  const _component_AppPageFrame = _resolveComponent("AppPageFrame")!

  return (_openBlock(), _createBlock(_component_AppPageFrame, { showHeader: "" }, {
    default: _withCtx(() => [
      (_unref(sessionState).session && !_unref(chromeless))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("h1", _hoisted_2, "Welcome back, " + _toDisplayString(_unref(sessionState).session.user.profile.firstName) + "!", 1)
          ]))
        : _createCommentVNode("", true),
      (_unref(sessionState).session && !_unref(chromeless))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(ApplicationStatusPanel)
          ]))
        : _createCommentVNode("", true),
      (carouselOffers.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _createVNode(OffersCarousel, {
              offers: carouselOffers.value,
              context: "home/carousel"
            }, null, 8, ["offers"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(OffersCategory, {
        class: "p-4",
        title: "Recommended Resources",
        description: "Here are some helpful resources based on your interests and needs.",
        offers: featuredOffers.value,
        context: "home/featured",
        viewAllLink: "/offers"
      }, null, 8, ["offers"])
    ]),
    _: 1
  }))
}
}

})